    $(document).ready(function(){

      $('.homePageBannerBtn').on('click', function(){
        //console.log('homePageBannerBtnClicked');
      });

      $('.bannerWatchBtn').on('click', function(){
        //console.log('bannerWatchBtnClicked');
      });


    });
